import React from "react";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
} from "react-table";

const DataTable = ({ columns, data }) => {
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
  } = tableInstance;

  return (
    <div className="container mx-auto text-dark">
      <div className="overflow-x-auto custom_scroll">
        <table
          {...getTableProps()}
          className="table-auto w-full"
        >
          <thead className="bg-light rounded-lg">
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id || index}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={column.id || index}
                    className="text-xs uppercase text-dark opacity-45 px-4 py-2 text-left text-nowrap"
                  >
                    {column.render("Header")}
                    <span className="ml-2">
                      {/* Sort icons */}
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <i className="bi bi-chevron-down"></i>
                        ) : (
                          <i className="bi bi-chevron-up"></i>
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={row.id} className="border-b border-[var(--light-bg6)]">
                  {row.cells.map((cell, index) => (
                    <td {...cell.getCellProps()} key={cell.column.id || index} className="px-4 py-2 text-nowrap">
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;
